import React from "react";
import PropTypes from "prop-types";

const JscypherEnabled = (props) => {
  const { className, style } = props;
  return (
    <svg
      className={className}
      style={style}
      width="21"
      height="25"
      viewBox="0 0 21 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9757 6.90893L20.9748 6.88264C20.9645 6.65511 20.9579 6.40942 20.9537 6.13218C20.9321 4.63555 19.7631 3.39752 18.2927 3.31435C15.6054 3.16139 13.5281 2.27135 11.7538 0.511346L11.7341 0.492226C11.0306 -0.164075 9.96969 -0.164075 9.26617 0.492226L9.2441 0.513736C7.47167 2.27183 5.39491 3.16187 2.70762 3.31435C1.23717 3.39752 0.0682393 4.63555 0.0466358 6.13218C0.0428786 6.40129 0.035834 6.64698 0.0255019 6.88264L0.024093 6.93426C-0.0299158 9.82189 -0.0975442 13.4155 1.09252 16.7018C1.75143 18.5211 2.74942 20.1032 4.05925 21.4039C5.54661 22.8809 7.49092 24.0525 9.83772 24.8852C9.92555 24.9162 10.0162 24.9416 10.1073 24.9597C10.2369 24.986 10.3689 24.9994 10.5004 24.9994C10.6319 24.9994 10.7643 24.986 10.893 24.9597C10.9841 24.9411 11.0757 24.9162 11.1644 24.8847C13.5084 24.0501 15.4504 22.8785 16.9359 21.4015C18.2452 20.0999 19.2432 18.5177 19.9026 16.6979C21.0969 13.4026 21.0297 9.80229 20.9757 6.90893ZM18.0522 16.0039C16.8476 19.3284 14.3815 21.6137 10.513 22.9904C10.5126 22.9904 10.5098 22.9913 10.506 22.9923C10.5018 22.9932 10.4985 22.9932 10.49 22.9913C10.4882 22.9908 10.4863 22.9904 10.4863 22.9904C6.61363 21.6161 4.14613 19.3317 2.94244 16.0077C1.88105 13.0766 1.94164 9.83429 1.99565 6.97059V6.9596C2.00692 6.7053 2.01443 6.44479 2.01819 6.16229C2.02476 5.71392 2.37606 5.34347 2.81752 5.31814C4.41195 5.22732 5.8143 4.91327 7.10535 4.35688C8.35319 3.81912 9.4653 3.07009 10.4999 2.0682C11.5355 3.07009 12.6476 3.8196 13.8945 4.35688C15.1855 4.91279 16.5879 5.22732 18.1823 5.31814C18.6242 5.34347 18.9751 5.71392 18.9816 6.16229C18.9859 6.45292 18.9934 6.7139 19.0042 6.96055C19.0577 9.82189 19.1174 13.0651 18.0522 16.0039Z"
        fill="#4871F0"
      />
      <path
        d="M10.4985 7.13729C8.58569 7.13729 7.0293 8.72139 7.0293 10.6683C7.0293 11.7505 7.52055 12.7763 8.35087 13.4422L8.33537 15.6171V15.6223C8.33537 16.8307 9.30142 17.814 10.4886 17.814C11.674 17.814 12.6401 16.8322 12.6419 15.6271L12.6574 13.4326C13.4802 12.7663 13.9677 11.7438 13.9677 10.6683C13.9677 8.72139 12.4113 7.13729 10.4985 7.13729ZM10.6887 13.0105L10.6699 15.6176V15.6228C10.6699 15.7246 10.5887 15.8073 10.4886 15.8073C10.3891 15.8073 10.3078 15.7246 10.3074 15.6266L10.3261 12.9689C10.3501 12.5751 10.1453 12.2027 9.80206 12.0182C9.308 11.7534 9.00085 11.2362 9.00085 10.6683C9.00085 9.82798 9.67244 9.14438 10.4985 9.14438C11.3241 9.14438 11.9957 9.82798 11.9957 10.6683C11.9957 11.2319 11.6919 11.7476 11.203 12.0139C10.8489 12.2065 10.6446 12.6052 10.6887 13.0105Z"
        fill="#4871F0"
      />
    </svg>
  );
};

JscypherEnabled.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

JscypherEnabled.defaultProps = {
  className: undefined,
  style: undefined,
};

export default JscypherEnabled;
